import {
  applyMiddleware,
  combineReducers,
  createStore,
  compose,
} from 'redux';
import LogRocket from 'logrocket';

import Targeting from './Targeting/reducer';
import Campaign from './Campaign/reducer';
import AdPlacement from './AdPlacement/reducer';
import Agents from './Agents/reducer';
import LeadAds from './LeadAds/reducer';

export const reducer = combineReducers({
  targeting: Targeting,
  leadAds: LeadAds,
  campaign: Campaign,
  adPlacement: AdPlacement,
  agents: Agents,
});


const rootReducer = (state, action) => {
  if (action.type === 'RESET_STORE') {
    state = undefined;
  }

  return reducer(state, action);
};

let composeEnhancers = compose;
if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
}

const middleware = [];
if (process.env.NODE_ENV === 'production') {
  middleware.push(LogRocket.reduxMiddleware());
}

export const createRGStore = (preloadedState) => createStore(
  reducer,
  preloadedState,
  composeEnhancers(
    applyMiddleware(...middleware),
  ),
);

const store = createRGStore();

export default store;

const { dispatch } = store;
export { dispatch };
